import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { AuthUser } from '../models/auth/AuthUser';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  messaging = getMessaging();
  currentMessage = new BehaviorSubject(null);
  currentUser = new AuthUser();

  constructor(private http: HttpClient, private auth: AuthenticationService) {
    this.currentUser = this.auth.currentUserValue;
  }

  requestPermission() {
    Notification.requestPermission().then(() => {
      if (this.isTokenSentToServer()) {
        // console.log("Token Already sent");
      } else {
        this.getRegisterToken();
      }
    }).catch((err) => {
      console.log('Unable to get permission to notify.', err);
    });
  }

  isTokenSentToServer() {
    return !!window.localStorage.getItem('fcmToken');
  }

  getRegisterToken() {
    getToken(this.messaging).then((currentToken) => {
      if (currentToken) {
        this.saveToken(currentToken);
        this.sendTokenToServer(currentToken);
      } else {
        console.log('No Instance ID token available. Request permission to generate one.');
        this.setTokenSentToServer();
      }
    }).catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
      this.setTokenSentToServer();
    });
  }

  setTokenSentToServer(token = null) {
    if (token) {
      window.localStorage.setItem('fcmToken', token);
    }
  }

  sendTokenToServer(currentToken: any) {
    if (!this.isTokenSentToServer()) {
      this.setTokenSentToServer(currentToken);
    } else {
      console.log('Token already sent to server so won\'t send it again ' +
        'unless it changes');
    }
  }

  saveToken(currentToken: string) {
    let data = {
      userId: this.currentUser.user.id,
      fmcToken: currentToken,
      // dateExpired: null
    }
    this.auth.createFmcToken(data).subscribe(
      (res) => {

      },
      (error: any) => {
        localStorage.removeItem('fcmToken');
        location.reload();
      });
  }

  receiveMessage() {
    onMessage(this.messaging, (payload: any) => {
      this.currentMessage.next(payload);
      let title = payload.notification.title;

      let options = {
        body: payload.notification.body,
        icon: payload.notification.icon,
        image: payload.data.image,
        data: {
          time: new Date(Date.now()).toString(),
          click_action: payload.data.click_action
        }
      };
      const notify = new Notification(title, options);
      notify.onclick = event => {
        event.preventDefault();
        window.location.href = environment.appUrl + '/Adaa/notification'
      }
    });
  }

  getNotifications(params: any): any {
    return this.http.get(`${environment.apiStock}/Notification`, { params });
  }
}
